module.exports = __webpack_public_path__ + "img/logo.218f6ecb.png";